var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Block, SylPlugin } from '@syllepsis/adapter';
import { NODE_NAME } from './const';
import { createCellAttrs, getCellAttrs, setCellAttrs } from './utils';
var createTableHeaderPlugin = function (props) {
    var TableHeaderItem = /** @class */ (function (_super) {
        __extends(TableHeaderItem, _super);
        function TableHeaderItem() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.name = NODE_NAME.TABLE_HEADER;
            _this.content = 'block+';
            _this.attrs = createCellAttrs(props.defaultCellWidth, props.cellAttributes);
            _this.tableRole = 'header_cell';
            _this.isolating = true;
            _this.parseDOM = [
                {
                    tag: 'th',
                    getAttrs: function (dom) { return getCellAttrs(dom, props.cellAttributes); }
                }
            ];
            _this.toDOM = function (node) { return ['th', setCellAttrs(node, props.cellAttributes), 0]; };
            return _this;
        }
        return TableHeaderItem;
    }(Block));
    return /** @class */ (function (_super) {
        __extends(TableHeaderPlugin, _super);
        function TableHeaderPlugin() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.Schema = TableHeaderItem;
            return _this;
        }
        return TableHeaderPlugin;
    }(SylPlugin));
};
export { createTableHeaderPlugin };
//# sourceMappingURL=table-header.js.map